var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_22",
  "data-name": "Ellipse 22",
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#fd4184"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_2375",
  "data-name": "Rectangle 2375",
  transform: "translate(4 4)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 8,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 7,
  height: 7,
  fill: "none"
}))));
export default __webpack_public_path__ + "static/media/not-fulfill-icon.56708946.svg";
export { SvgComponent as ReactComponent };